module.exports = __webpack_public_path__ + "img/trafikklys.6b596e67.jpg";